export enum ModalId {
  AboutReviews,
  Accidents,
  Account,
  Activation,
  AddCoApplicant,
  AppraisalEmbedded,
  AppraisalRefresh,
  Availability,
  ComposerUi,
  Confirm,
  EditCoApplicant,
  FeaturesAndSpecs,
  FinanceActivation,
  FullScreenGallery,
  GeicoDiscount,
  GeoLocation,
  GetAlerts,
  InspectionReport,
  LockTimer,
  MarketValue,
  MoreDetails,
  CatalogOemFeatures,
  OnLoadAlert,
  OriginalBrochure,
  Partner,
  Petition,
  PreOrder,
  PurchaseCompleted,
  Recall,
  Reservable,
  ReservableCancel,
  ReturnPolicy,
  RootDiscount,
  SampleTerms,
  Savings,
  Shipping,
  SimilarVehicles,
  SoftPull,
  StarRatingOwnerReview,
  TradeIncentive,
  WhyBuy
}

export const ModalPriorities = {
  [ModalId.Account]: 3,
  [ModalId.Activation]: 3,
  [ModalId.FinanceActivation]: 3,
  [ModalId.GeoLocation]: 3,
  [ModalId.PurchaseCompleted]: 3,

  [ModalId.Availability]: 2,
  [ModalId.OnLoadAlert]: 2,

  [ModalId.AddCoApplicant]: 1,
  [ModalId.AppraisalEmbedded]: 1,
  [ModalId.AppraisalRefresh]: 1,
  [ModalId.EditCoApplicant]: 1,
  [ModalId.LockTimer]: 1,
  [ModalId.RootDiscount]: 1,
  [ModalId.SoftPull]: 1
};

export enum NativeModalId {
  Geolocation = 'geolocation',
  SoftPull = 'softpull'
}

export enum ComposerModalName {
  SoftPull = 'softpull'
}

/**
 * Enum for withModalOpen parameter values
 * Used to specify which modal should be opened automatically when the VDP page loads
 */
export enum WithModalOpenType {
  Geolocation = 'geolocation',
  SoftPull = 'softpull',
  Vehicle150Point = 'vehicle150pt'
}
